/**
 * AppHeader — persistent top bar on all inner pages.
 * Hidden on Home (which has its own dark navbar).
 * Layout: back arrow | FLYERS FEAST BETA (→ home) | theme toggle | user menu
 */
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft, Sun, Moon } from 'lucide-react';
import { useTheme } from '@/hooks/useTheme';
import UserMenu from '@/components/UserMenu';
import { ROUTE_PATHS } from '@/lib/index';

export default function AppHeader() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { dark, toggle } = useTheme();

  // Hide on home page
  if (pathname === '/' || pathname === '') return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur border-b border-border/50 h-12 flex items-center px-3 gap-2">
      {/* Back */}
      <button
        onClick={() => navigate(-1)}
        className="w-8 h-8 rounded-lg bg-muted hover:bg-muted/80 flex items-center justify-center transition-colors shrink-0"
      >
        <ArrowLeft className="w-4 h-4 text-muted-foreground" />
      </button>

      {/* Brand wordmark centred — tap to go home */}
      <button
        onClick={() => navigate(ROUTE_PATHS.HOME)}
        className="flex-1 flex justify-center items-center gap-1.5 select-none"
      >
        <span className="text-sm font-black tracking-tight text-foreground uppercase">
          FLYERS FEAST
        </span>
        <span
          className="text-xs font-black tracking-widest uppercase"
          style={{
            color: '#4ade80',
            textShadow: '0 0 10px rgba(74,222,128,0.75), 0 0 22px rgba(74,222,128,0.4)',
          }}
        >
          BETA
        </span>
      </button>

      {/* Theme toggle */}
      <button
        onClick={toggle}
        className="w-8 h-8 rounded-lg bg-muted hover:bg-muted/80 flex items-center justify-center transition-colors shrink-0"
        title={dark ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {dark
          ? <Sun  className="w-4 h-4 text-amber-400" />
          : <Moon className="w-4 h-4 text-muted-foreground" />}
      </button>

      {/* User menu */}
      <div className="shrink-0">
        <UserMenu />
      </div>
    </div>
  );
}
